import NewType from './NewType'

export default NewType



// WEBPACK FOOTER //
// ./src/components/Types/New/index.js